import groupBy from 'lodash.groupby'

export default (data: any) => {
  const dateWithoutTimePosts = data
    .filter((post: any) => !post.isDraft)
    .map((o: any) => ({
      ...o,
      dateWithoutTime: new Date(o.when).toDateString(),
    }))

  const groupedPosts = groupBy(dateWithoutTimePosts, 'dateWithoutTime')
  const posts = Object.keys(groupedPosts).map((dateWithoutTime) => {
    return {
      date: dateWithoutTime,
      posts: groupedPosts[dateWithoutTime],
    }
  })

  // prepend draft posts
  const draftPosts = data.filter((post: any) => post.isDraft).reverse()
  posts.push({
    date: 'drafts',
    posts: draftPosts,
  })

  return posts
}
